import { SUCCESS, FETCH_EXHIBITOR_LIST } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_EXHIBITOR_LIST, UPDATED } from '../constants/socket';

export default (state = initialState.exhibitorLists, { type, payload }) => {
  switch (type) {
    case FETCH_EXHIBITOR_LIST + SUCCESS:
    case SC_EXHIBITOR_LIST + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
